export default {
  title: 'Anzeigeeinstellungen',
  subtitle: 'Wählen Sie die Diagramme aus, die Sie auf dem Dashboard anzeigen möchten, aus den unten stehenden Listen aus.',
  aggregationTitle: 'Aggregation',
  aggregationDescription: 'Diese Diagramme zeigen die Effizienz für den gesamten ausgewählten Zeitraum an.',
};
